'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promiseClient = require('../adapters/promiseClient');

var _promiseClient2 = _interopRequireDefault(_promiseClient);

var _noAuthWithCredentialsHubapi = require('../stacks/noAuthWithCredentialsHubapi');

var _noAuthWithCredentialsHubapi2 = _interopRequireDefault(_noAuthWithCredentialsHubapi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _promiseClient2.default)(_noAuthWithCredentialsHubapi2.default);
module.exports = exports['default'];